<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled'
                                    : props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="financeSession.shopId"
                  :items="shopList"
                  color="blue-grey lighten-2"
                  label="Choose Shop..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :readonly="financeSession.id ? true :false || user.role.roleName == 'BRANCH_ADMIN'"
                  :rules="rules.shopRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12 v-if="financeSession.id">
                <v-text-field
                  name="name"
                  label="Finance Session Code"
                  v-model="financeSession.code"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-select
                  v-model="financeSession.financeSettingId"
                  :items="financeSettingList"
                  color="blue-grey lighten-2"
                  label="Choose Finance Setting..."
                  item-text="financialYearName"
                  menu-props="auto"
                  item-value="id"
                  @input="bindMonth(financeSession.financeSettingId)"
                  :rules="rules.financeSettingRules"
                  :disabled="financeSession.id ? true :false"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="yearMonth"
                  lazy
                  transition="scale-transition"
                  offest-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="yearMonth"
                      label="Month"
                      prepend-icon="event"
                      :disabled="financeSession.id ? true :false"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="yearMonth"
                    type="month"
                    :min="minMonth"
                    :max="maxMonth"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="$refs.menu.save(yearMonth)">Ok</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="financeSession.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="financeSession.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="financeSession.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="financeSession.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="financeSession.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="financeSession.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" :disabled="financeSession.id ? true :false" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid || financeSession.id ? true :false"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>
<script>
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { FinanceSession } from "../../models/model";
import { shopService } from "../../services/shop-service";
import { financeSessionService } from "../../services/finance-session-service";
import { commonService } from "../../services/common-service";
import { financeSettingService } from "../../services/finance-setting-service";
import { FinanceSessionFormRules } from "../../helpers/validation-rules";

export default {
  name: "FinanceSessionDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Finance Sessions",
        disabled: false,
        to: "finance-sessions",
      },
      {
        text: "Finance Sessioin Detail",
        disabled: true,
      },
    ],
    responseError: "",
    createdDate: "",
    updatedDate: "",
    yearMonth: "",
    minMonth: "",
    maxMonth: "",
    menu: false,
    saveLoading: false,
    shopList: [],
    financeSettingList: [],
    financeSession: new FinanceSession(),
    oldFinanceSession: new FinanceSession(),
    rules: new FinanceSessionFormRules(),
  }),
  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.financeSession.shopId = this.user.shopId;
    }
    const id = this.$route.params.id;
    this.getAllShop();
    this.getFinanceSettingList();
    if (id == "new") {
      //new
      this.yearMonth = new Date().toISOString().substr(0, 7);
    } else {
      this.getFinanceSessionDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        let financeSessionObj = {
          id: this.financeSession.id ? this.financeSession.id : "",
          financeSettingId: this.financeSession.financeSettingId,
          code: this.financeSession.code,
          yearMonth: this.yearMonth,
          shopId: this.financeSession.shopId,
        };
        financeSessionService
          .saveFinanceSession(financeSessionObj)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getFinanceSessionDetail(id) {
      financeSessionService.getFinanceSessionDetail(id).then((res) => {
        this.financeSession = res.data;
        this.yearMonth = res.data.yearMonth;
        this.createdDate = commonService.formatDate(
          new Date(this.financeSession.createdDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.updatedDate = commonService.formatDate(
          new Date(this.financeSession.updatedDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
      });
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    goBack() {
      this.$router.push("/finance-sessions");
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.financeSession.id) {
        this.financeSession = new FinanceSession();
      } else {
        this.financeSession = Object.assign({}, this.oldFinanceSession);
      }
    },
    getFinanceSettingList() {
      financeSettingService
        .getAllFinanceSetting()
        .then((res) => {
          this.financeSettingList = res.data.financeSettingDTOs;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.response = err.response.data.message;
          }
        });
    },
    bindMonth(id) {
      let financeSetting = commonService.search(
        "id",
        id,
        this.financeSettingList
      );
      this.minMonth = financeSetting.startMonth;
      this.maxMonth = financeSetting.endMonth;
      this.yearMonth = financeSetting.startMonth;
    },
  },
};
</script>